/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_CarddetailsInputs */

const en_visa_eb1_carddetails = /** @type {(inputs: Visa_Eb1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment-based immigrant classification for certain people with extraordinary ability, outstanding professors or researchers, and qualifying multinational executives or managers.`)
};

const pt_visa_eb1_carddetails = /** @type {(inputs: Visa_Eb1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação imigratória baseada em emprego para certas pessoas com habilidade extraordinária, professores ou pesquisadores destacados e executivos ou gerentes multinacionais qualificados.`)
};

const es_visa_eb1_carddetails = /** @type {(inputs: Visa_Eb1_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación migratoria basada en empleo para ciertas personas con habilidad extraordinaria, profesores o investigadores destacados y ejecutivos o gerentes multinacionales calificados.`)
};

/**
* | output |
* | --- |
* | "Employment-based immigrant classification for certain people with extraordinary ability, outstanding professors or researchers, and qualifying multinational ..." |
*
* @param {Visa_Eb1_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_carddetails = /** @type {((inputs?: Visa_Eb1_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_carddetails(inputs)
	if (locale === "es") return es_visa_eb1_carddetails(inputs)
	return en_visa_eb1_carddetails(inputs)
});